const fileIcons = {
    "fileTypeMap": {
        "Picture": ["png", "jpg", "jpeg", "gif", "bmp"],
        "Audio": ["mp3", "ogg", "wav"],
        "Video": ["flv", "swf", "mkv", "avi", "rm", "rmvb", "mpeg", "mpg", "ogv", "mov", "wmv", "mp4", "webm", "mid"],
        "Webpage": ["xml", "html", "htm", "aspx", "asp", "jsp", "php", "shtml", "nsp"],
        "PowerPoint": ["ppt", "pptx", "pptm", "ppsx", "ppsm", "potx", "potm", "ppam"],
        "World": ["doc", "docx", "docm", "dotx", "dotm"],
        "Excel": ["xls", "xlsx", "xlsm", "xltx", "xltm", "xlsb", "xlam"],
        "Pdf": ["pdf"],
        "Zip": ["zip", "rar", "tar", "gz", "jar", "iso", "z", "arj"]
    },
    "fileIcon": {
        "Zip": "rar-big-icon.png",
        "World": "word-big-icon.png",
        "PowerPoint": "ppt-big-icon.png",
        "Excel": "excel-big-icon.png",
        "Webpage": "web-big-icon.png",
        "Pdf": "pdf-big-icon.png",
        "OtherFile": "noFile-big.png"
    },
    "base": "images/"
}

class Constant {

    configPagesize=5;

    fileType(tplData) {
        let typeName = "OtherFile";
        let ext = tplData.ZykOtherFile_ext || tplData.ext;
        for (let key in fileIcons.fileTypeMap) {
            fileIcons.fileTypeMap[key].map(function (item) {
                if (ext == item) {
                    typeName = key;
                    return false;
                }
            })
        }
        return typeName;
    };

    fileIcon(ext) {
        let typeName = this.fileType({ext: ext ? ext.toLowerCase() : ''});
        if (typeName) {
            let iconPath = fileIcons.fileIcon[typeName];
            if (iconPath) {
                return fileIcons.base + iconPath;
            }
        }
        return fileIcons.base + fileIcons.fileIcon.OtherFile;
    };

    duration(tplData) {
        var size = tplData.ZykAudio_allTime || tplData.ZykVideo_allTime || tplData.allTime;
        var secondTime = isNaN(parseInt(size)) ? 0 : parseInt(size) / 1000;// 秒
        var minuteTime = 0;// 分
        var hourTime = 0;// 小时
        if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
            //获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60);
            //获取秒数，秒数取佘，得到整数秒数
            secondTime = parseInt(secondTime % 60);
            //如果分钟大于60，将分钟转换成小时
            if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        var result = "" + parseInt(secondTime) + "秒";
        if (minuteTime > 0) {
            result = "" + parseInt(minuteTime) + "分" + result;
        }
        if (hourTime > 0) {
            result = "" + parseInt(hourTime) + "小时" + result;
        }
        return result;
    }

    getDataSource(type) {
        switch (type) {
            case 1 :
                return "写稿";
                break;
            case 2 :
                return "约稿";
                break;
            case 3 :
                return "选题";
                break;
            case 4 :
                return "任务";
                break;
            case 5 :
                return "资源上传";
                break;
            case 6 :
                return "融媒";
                break;
            case 7:
                return "投稿";
                break;
            default :
                return "无数据";
                break;
        }
    }
}

export default new Constant();